import { Relays } from 'constants/Relays';
import { ProductCode } from 'phoenix/constants/PremiumProducts';
import { GetRelay, SetRelay, useRelay } from 'phoenix/hooks/UseRelay';

export const useShowPremiumUpgradeModal = () => useRelay<ProductCode | false>(Relays.ShowPremiumUpgradeModal)
export const SetShowPremiumUpgradeModal = (isOpenForProduct: ProductCode | false) => SetRelay(Relays.ShowPremiumUpgradeModal, isOpenForProduct)
export const GetShowPremiumUpgradeModal = () => GetRelay(Relays.ShowPremiumUpgradeModal)